import { compareAsc, parseISO } from 'date-fns';
import { SecurityModel } from 'api';

const hasInvestmentDate = (security: SecurityModel): security is SecurityModel & { investment_date: string } =>
  Boolean(security.investment_date);

const compareByOrder = (a: SecurityModel, b: SecurityModel) =>
  (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER);

const compareByLatestInvestmentDate = (a: SecurityModel, b: SecurityModel) => {
  const dateCompare = compareAsc(parseISO(a.investment_date!), parseISO(b.investment_date!));
  if (dateCompare === 0) {
    return compareByOrder(a, b);
  }
  return -dateCompare;
};

const getDefaultBasketSecurity = (securities: SecurityModel[]): SecurityModel | undefined => {
  if (securities.length === 0) {
    return undefined;
  }

  const securitiesWithInvestmentDate = securities.filter(hasInvestmentDate);
  if (securitiesWithInvestmentDate.length > 0) {
    return [...securitiesWithInvestmentDate].sort(compareByLatestInvestmentDate)[0];
  }

  return [...securities].sort(compareByOrder)[0];
};

export default getDefaultBasketSecurity;
